import { Companion_getInstance33aui7uk8ap15 as Companion_getInstance } from './data.commonHtml.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.kbb_1 = new (ScreenTransitions())(Companion_getInstance().qax_1, Companion_getInstance().qax_1, Companion_getInstance().qax_1);
        this.lbb_1 = new (ScreenTransitions())(Companion_getInstance().rax_1, Companion_getInstance().sax_1, Companion_getInstance().vax_1);
        this.mbb_1 = new (ScreenTransitions())(Companion_getInstance().vax_1, Companion_getInstance().vax_1, Companion_getInstance().vax_1);
        this.nbb_1 = new (ScreenTransitions())(Companion_getInstance().wax_1, Companion_getInstance().xax_1, Companion_getInstance().vax_1);
        this.obb_1 = new (ScreenTransitions())(Companion_getInstance().tax_1, Companion_getInstance().uax_1, Companion_getInstance().vax_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ScreenTransitionsClass;
function ScreenTransitions() {
  if (ScreenTransitionsClass === VOID) {
    class $ {
      constructor(forward, reverse, neutral) {
        Companion_getInstance_0();
        this.pbb_1 = forward;
        this.qbb_1 = reverse;
        this.rbb_1 = neutral;
      }
      toString() {
        return 'ScreenTransitions(forward=' + toString(this.pbb_1) + ', reverse=' + toString(this.qbb_1) + ', neutral=' + toString(this.rbb_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.pbb_1);
        result = imul(result, 31) + hashCode(this.qbb_1) | 0;
        result = imul(result, 31) + hashCode(this.rbb_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ScreenTransitions()))
          return false;
        if (!equals(this.pbb_1, other.pbb_1))
          return false;
        if (!equals(this.qbb_1, other.qbb_1))
          return false;
        if (!equals(this.rbb_1, other.rbb_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ScreenTransitions');
    ScreenTransitionsClass = $;
  }
  return ScreenTransitionsClass;
}
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance2k9zaro5cmj1m,
};
//endregion

//# sourceMappingURL=ScreenTransitions.mjs.map
